/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbCiClass {
    getFixupPrototypeFunction() { return ServiceNowCmdbCiClass.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbCiClass>): ServiceNowCmdbCiClass {
        let obj = Object.assign(new ServiceNowCmdbCiClass(), model);
        ServiceNowCmdbCiClass.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbCiClass>): ServiceNowCmdbCiClass {
        if (!model) return null;
        return ServiceNowCmdbCiClass.newInstance(<ServiceNowCmdbCiClass> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbCiClass) {
        if (!obj) return;

        models.ServiceNowCmdbCiClass.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbCiClass): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbCiClass.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the Cmdb Ci Class
     */
    name: string;

    /**
     * Display Name of the Cmdb Ci Class
     */
    label: string;

}
